export default "__VITE_PUBLIC_ASSET__5f273666__"